/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
// import {toAbsoluteUrl} from '../../../../../../components/helpers'
// import {User} from '../../core/_models'

type Props = {
  country: string
}

const AddressCell: FC<Props> = ({country}) => {
  return (
    <div className='align-items-center'>
      <div className='d-flex flex-row gap-1'>
        <div>{country}</div>
      </div>
    </div>
  )
}

export {AddressCell}

// {
//     "_id": "64118388bbc2463307484b89",
//     "name": "TSTVEQVYX",
//     "shippingMethods": "DOMESTIC",
//     "marketplaceReference": "TSTVEQVYX",
//     "reference": "31-ORDER-1678869384742",
//     "totalAmount": "30.000000",
//     "paidThrough": "Bank transfer",
//     "customer": {
//         "_id": "64105b3b00910ab7fcf72abf",
//         "firstname": "Farouk",
//         "lastname": "Benabed",
//         "address": {
//             "zipCode": "12508",
//             "city": "Tripoli",
//             "street": "Tripoli",
//             "country": "Tunisia",
//             "delegation": "Tripoli"
//         },
//         "email": "faroukbenabed@gmail.com",
//         "phoneNumber": "50000000",
//         "createDate": "2023-03-14T11:32:11.484Z",
//         "updateDate": "2023-03-14T11:32:11.484Z",
//         "__v": 0
//     },
//     "createdBy": "63f78082fc1c6f259ad7b323",
//     "createDate": "2023-03-15T08:36:24.745Z",
//     "updateDate": "2023-03-15T08:36:24.745Z",
//     "__v": 0
// }
